export default class NoteComment {
    constructor(data) {
        this.id = data.id;
        this.content = data.content;
        this.userId = data.userId;
        this.createdAt = new Date(data.createdAt);
        this.updatedAt = new Date(data.updatedAt);
    }
}